// =================
// Generic functions
// =================
function mergeRight(left, right) {
    return right === undefined ? left : right;
}
/**
 * Executes the given function only if the two arguments are both not `undefined`,
 * otherwise returns the not `undefined` argument if existing or returns `undefined`
 */
function execute(fn, x1, x2) {
    return x1 !== undefined && x2 !== undefined ? fn(x1, x2) : mergeRight(x1, x2);
}
/**
 * Given the way an element is merged into a list, merge two lists
 */
function merge(mergeSingleIntoArray, l1, l2) {
    if (l1.length === 0) {
        return l2;
    }
    else {
        const [h, ...t] = l1;
        return mergeSingleIntoArray(h, merge(mergeSingleIntoArray, t, l2));
    }
}
// ==================================
// Generic functions on `RouteObject`
// ==================================
function hasSamePath(left, right) {
    return left.path === right.path;
}
/**
 * Given the way to merge two extended `RouteObject`s, merge an extended `RouteObject` into an array
 */
function mergeSingleObjectIntoArray(mergeObjects, x, l) {
    if (l.length === 0) {
        return [x];
    }
    else {
        const [h, ...t] = l;
        if (hasSamePath(x, h)) {
            return [mergeObjects(x, h), ...t];
        }
        else {
            return [h, ...mergeSingleObjectIntoArray(mergeObjects, x, t)];
        }
    }
}
// ===============
// Implementations
// ===============
function mergeObjects(left, right) {
    return Object.assign(Object.assign({}, right), { path: mergeRight(left.path, right.path), index: mergeRight(left.index, right.index), element: mergeRight(left.element, right.element), caseSensitive: mergeRight(left.caseSensitive, right.caseSensitive), children: execute(mergeRouteObjectArrays, left.children, right.children) });
}
const mergeGlueRouteObjects = (left, right) => (Object.assign(Object.assign({}, mergeObjects(left, right)), { i18nDisable: mergeRight(left.i18nDisable, right.i18nDisable) }));
const mergeSingleRouteObjectIntoArray = (x, l) => mergeSingleObjectIntoArray(mergeObjects, x, l);
const mergeSingleGlueRouteObjectIntoArray = (x, l) => mergeSingleObjectIntoArray(mergeGlueRouteObjects, x, l);
const mergeRouteObjectArrays = (l1, l2) => merge(mergeSingleRouteObjectIntoArray, l1, l2);
export const mergeGlueRouteObjectArrays = (l1, l2) => merge(mergeSingleGlueRouteObjectIntoArray, l1, l2);
// =========================
// Pseudo code (ocaml style)
// =========================
// For merging two RouteObject lists:
//
// let rec merge (l1: RouteObject list) (l2: RouteObject list) =
//   | [] l2 -> l2
//   | h::t l2 -> merge t (aux h l2)
//
// let rec aux (x: RouteObject) (l: RouteObject list) =
//   | x [] -> [x]
//   | x h::t -> if (x.path === h.path) # both undefined or both string
//                   then let q = {
//                                  path: h.path,
//                                  index: mergeRight x.index h.index,
//                                  element: mergeRight x.element h.element,
//                                  caseSensitive: mergeRight x.caseSensitive h.caseSensitive,
//                                  children: merge x.children h.children, # with `undefined` treated carefully...
//                                }
//                   in q::t
//               else h::(aux x t)
//# sourceMappingURL=routeObjectHelpers.js.map